<!--src/components/common/SignStatsCard.vue-->
<!-- 首页广告区域专用签到积分卡片（引用自 UserInfoCard stats-panel） -->
<template>
  <!-- 积分明细弹窗 -->
  <el-dialog
    v-model="showPointsDetail"
    title="积分明细"
    width="500px"
    class="points-detail-dialog"
  >
    <div class="points-detail-content">
      <div
        v-if="pointsDetailList.length === 0"
        class="points-detail-empty"
      >
        暂无积分明细记录
      </div>
      <div
        v-else
        class="points-detail-list"
      >
        <div
          v-for="item in pointsDetailList"
          :key="item.id"
          class="points-detail-item"
        >
          <div class="points-detail-info">
            <div
              class="points-detail-desc"
              v-html="item.description.replace(/\n/g, '<br>')"
            />
            <div class="points-detail-time">
              {{ formatDetailTime(item.created_at) }}
            </div>
          </div>
          <div
            class="points-detail-change"
            :class="item.points_change > 0 ? 'positive' : 'negative'"
          >
            {{ item.points_change > 0 ? '+' : '' }}{{ item.points_change }}
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 签到成功弹窗 -->
  <el-dialog
    v-model="showSignDialog"
    title=""
    width="320px"
    :show-close="false"
    class="sign-dialog"
  >
    <div class="sign-success-content">
      <div class="sign-icon">
        ✅
      </div>
      <div class="sign-title">
        签到成功！
      </div>
      <div class="sign-points">
        +{{ signResult.pointsEarned }} 积分
      </div>
      <div class="sign-info">
        <div>当前积分：{{ signResult.newPoints }}</div>
        <div>连续签到：{{ signResult.continuousDays }}天</div>
      </div>
      <div
        v-if="signResult.isExtraReward"
        class="extra-reward"
      >
        🏆 连续签到奖励已发放！等级提升至 Lv.{{ signResult.newLevel }} {{ signResult.newTitle }}
      </div>
      <div
        v-else-if="signResult.nextExtraRewardDays"
        class="reward-tip"
      >
        🎯 再签到{{ signResult.nextExtraRewardDays }}天可领取连续签到奖励！
      </div>
      <button
        class="btn-confirm"
        @click="showSignDialog = false"
      >
        太棒了！
      </button>
    </div>
  </el-dialog>

  <!-- 积分规则弹窗 -->
  <el-dialog
    v-model="showRulesDialog"
    title="积分规则"
    width="700px"
    class="rules-dialog"
    :style="{ top: 'calc(50vh - 40px)', marginTop: '-500px' }"
  >
    <div class="rules-content">
      <div class="rules-section">
        <div class="rules-title">
          📋 积分获取
        </div>
        <div class="rules-item">
          注册：默认Lv.0级
        </div>
        <div class="rules-item">
          绑定任一平台账号：+10积分
        </div>
        <div class="rules-item">
          每日签到（周一~六）：+1积分
        </div>
        <div class="rules-item">
          周日签到：+2积分
        </div>
        <div class="rules-item">
          连续签到满7天（周日）：额外+2积分
        </div>
        <div class="rules-item">
          确认收货（需完成对接的购物平台）：+1积分
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          👑 会员权益
        </div>
        <div class="rules-item">
          Lv.0：可在不折不扣平台获取各大权威平台的优惠购物、活动频道、抢券秒杀等精彩内容，省钱购物。
        </div>
        <div class="rules-item">
          Lv.1~Lv.3：优惠购物。领取"布衣天子"称号，享受不折不购平台返现权益（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.4~Lv.6：优惠购物。领取"登堂入室"称号，不折不购平台返现比例增加10%（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.7~Lv.9：优惠购物。领取"富甲一方"称号，不折不购平台返现比例增加20%（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.10：优惠购物。领取"天下豪绅"称号，不折不购平台返现比例增加30%（需完成对接的平台）。
        </div>
        <div class="rules-item rules-note">
          * 以上会员权益解释权归不折不购平台所有，更多会员权益持续开发中~
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          ⬆️ 升级说明
        </div>
        <table class="rules-table">
          <thead>
            <tr>
              <th>等级</th>
              <th>称号</th>
              <th>积分门槛</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Lv.0</td><td>稚子蒙学</td><td>0</td></tr>
            <tr><td>Lv.1</td><td>布衣天子</td><td>10~99</td></tr>
            <tr><td>Lv.2</td><td>布衣天子</td><td>100~299</td></tr>
            <tr><td>Lv.3</td><td>布衣天子</td><td>300~599</td></tr>
            <tr><td>Lv.4</td><td>登堂入室</td><td>600~999</td></tr>
            <tr><td>Lv.5</td><td>登堂入室</td><td>1000~1499</td></tr>
            <tr><td>Lv.6</td><td>登堂入室</td><td>1500~2499</td></tr>
            <tr><td>Lv.7</td><td>富甲一方</td><td>2500~4499</td></tr>
            <tr><td>Lv.8</td><td>富甲一方</td><td>4500~6999</td></tr>
            <tr><td>Lv.9</td><td>富甲一方</td><td>7000~9999</td></tr>
            <tr><td>Lv.10</td><td>天下豪绅</td><td>10000+</td></tr>
          </tbody>
        </table>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          🏆 补签权益
        </div>
        <div class="rules-item">
          登堂入室（Lv.4-6）：本周可补签1次
        </div>
        <div class="rules-item">
          富甲一方（Lv.7-9）：本周可补签2次
        </div>
        <div class="rules-item">
          天下豪绅（Lv.10）：本周可补签3次
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          📆 签到周期
        </div>
        <div class="rules-item">
          每周一至周日为一个周期
        </div>
        <div class="rules-item">
          周日是本周最后一天
        </div>
        <div class="rules-item">
          补签仅限本周内，跨周失效
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 签到积分卡片主体 -->
  <div class="sign-stats-card">
    <!-- 左边：积分 + 称号 -->
    <div class="stats-left">
      <div class="stat-item stat-points">
        <span class="stat-label">💰 我的积分</span>
        <span class="stat-value">{{ userStore.userInfo.points || 0 }}</span>
      </div>
      <div class="stat-item">
        <span class="title-icon">🏆</span>
        <span class="title-label">称号：</span>
        <span
          class="level-badge"
          :class="getLevelClass(userStore.userInfo.level)"
        >
          {{ userStore.userInfo.title }}
        </span>
      </div>
    </div>

    <!-- 右边：规则+签到按钮 -->
    <div class="stats-right">
      <!-- 右上：积分明细 + 规则按钮 -->
      <div class="stats-right-top">
        <button
          class="btn-points-detail-inline"
          @click="handleShowPointsDetail"
        >
          积分明细
        </button>
        <button
          class="btn-rule-circle"
          @click="showRulesDialog = true"
        >
          ?
        </button>
      </div>
      <!-- 右下：签到按钮 -->
      <div class="stats-right-bottom">
        <button
          v-if="!userStore.signStatus.signedToday"
          class="btn-sign-small"
          @click="handleSign"
        >
          🎁 点击签到
        </button>
        <button
          v-else
          class="btn-signed-small"
          disabled
        >
          ✅ 今日已签到
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/store/modules/userStore'

const userStore = useUserStore()

// 弹窗状态
const showSignDialog = ref(false)
const showRulesDialog = ref(false)
const showPointsDetail = ref(false)
const pointsDetailList = ref([])
const signResult = ref({})

// 签到
const handleSign = async () => {
  if (!userStore.hasLogin) {
    ElMessage.warning('请先登录')
    return
  }
  const result = await userStore.doSign()
  if (result.success) {
    signResult.value = {
      pointsEarned: result.pointsEarned,
      newPoints: result.newPoints,
      continuousDays: result.continuousDays,
      isSunday: result.isSunday,
      isExtraReward: result.isExtraReward,
      newLevel: result.newLevel,
      newTitle: result.newTitle,
      nextExtraRewardDays: result.continuousDays ? (7 - result.continuousDays) : 7
    }
    showSignDialog.value = true
  } else {
    ElMessage.warning(result.msg || '签到失败')
  }
}

// 获取等级样式
const getLevelClass = (level) => {
  if (level >= 10) return 'level-10'
  if (level >= 7) return 'level-7'
  if (level >= 4) return 'level-4'
  if (level >= 1) return 'level-1'
  return 'level-0'
}

// 积分明细
const handleShowPointsDetail = async () => {
  if (!userStore.hasLogin) {
    ElMessage.warning('请先登录')
    return
  }
  showPointsDetail.value = true
  if (pointsDetailList.value.length === 0) {
    await fetchPointsDetail()
  }
}

// 获取积分明细列表
const fetchPointsDetail = async () => {
  try {
    const res = await fetch('/api/users/points-log?page=1&pageSize=50', {
      headers: {
        'Authorization': `Bearer ${userStore.accessToken}`
      }
    })
    const data = await res.json()
    if (data.code === 0) {
      pointsDetailList.value = data.data || []
    }
  } catch (e) {
    console.error('获取积分明细失败:', e)
  }
}

// 格式化时间
const formatDetailTime = (time) => {
  if (!time) return ''
  const d = new Date(time)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";

.sign-stats-card {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  min-width: 220px;
  height: 80px;
  padding: 8px 10px;
  background: linear-gradient(135deg, #fff0f0, #fff);
  border-radius: 12px;
  border: 1px solid #ffe0e0;
  box-sizing: border-box;
  overflow: hidden;
}

.stats-left {
  flex: 6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
}

.stats-right {
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
}

.stats-right-top {
  display: flex;
  align-items: center;
  gap: 5px;
}

.stats-right-bottom {
  display: flex;
  align-items: flex-start;
}

.stat-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
}

.stat-points {
  justify-content: flex-start;
}

.stat-label {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.stat-value {
  font-size: 16px;
  font-weight: bold;
  color: #fd0000;
  line-height: 1;
}

.title-icon {
  font-size: 12px;
}

.title-label {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

/* 签到按钮 */
.btn-sign-small {
  padding: 1px 8px;
  background: linear-gradient(135deg, #fd0000, #ff6b6b);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.8;
  margin: 0;
}

.btn-signed-small {
  padding: 1px 8px;
  background: #f0f0f0;
  color: #999;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  white-space: nowrap;
  line-height: 1.8;
  margin: 0;
}

/* 圆形规则按钮 */
.btn-rule-circle {
  width: 20px;
  height: 20px;
  background: #fff;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 积分明细按钮 */
.btn-points-detail-inline {
  padding: 1px 6px;
  background: transparent;
  color: #fd0000;
  border: 1px solid #fd0000;
  border-radius: 6px;
  font-size: 10px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.6;
  margin: 0;
}

/* 等级徽章 */
.level-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  white-space: nowrap;
}

.level-0 { background: #f5f5f5; color: #999; }
.level-1 { background: #e6f7ff; color: #1890ff; }
.level-4 { background: #fff7e6; color: #fa8c16; }
.level-7 { background: #fff1f0; color: #f5222d; }
.level-10 { background: #fff7e6; color: #d4380d; }

/* ========== 弹窗样式 ========== */

/* 签到成功弹窗 */
.sign-dialog {
  border-radius: 16px !important;
  overflow: hidden;

  :deep(.el-dialog) {
    border-radius: 16px !important;
    overflow: hidden;
  }
}

.sign-success-content {
  text-align: center;
  padding: 10px 0 5px;

  .sign-icon { font-size: 48px; margin-bottom: 8px; }
  .sign-title { font-size: 20px; font-weight: bold; color: #333; margin-bottom: 6px; }
  .sign-points { font-size: 24px; font-weight: bold; color: #fd0000; margin-bottom: 8px; }
  .sign-info { font-size: 13px; color: #666; margin-bottom: 8px; }
  .extra-reward { font-size: 13px; color: #ff6b00; background: #fff7e6; padding: 6px; border-radius: 8px; margin-bottom: 8px; }
  .reward-tip { font-size: 13px; color: #666; margin-bottom: 8px; }
}

.btn-confirm {
  width: 100%;
  height: 40px;
  background: linear-gradient(135deg, #fd0000, #ff6b6b);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  cursor: pointer;
  margin-top: 5px;
}

/* 积分明细弹窗 */
.points-detail-dialog {
  :deep(.el-dialog) {
    border-radius: 14px;
  }
}

.points-detail-content {
  max-height: none;
  overflow-y: visible;
}

.points-detail-empty {
  text-align: center;
  padding: 30px;
  color: #999;
  font-size: 14px;
}

.points-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child { border-bottom: none; }
}

.points-detail-info {
  flex: 1;
  min-width: 0;
}

.points-detail-desc {
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}

.points-detail-time {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.points-detail-change {
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
  margin-left: 10px;
}

.points-detail-change.positive { color: #fd0000; }
.points-detail-change.negative { color: #52c41a; }

/* 积分规则弹窗 */
.rules-dialog {
  :deep(.el-dialog) {
    border-radius: 14px;
  }
}

.rules-content {
  max-height: none;
  overflow-y: visible;
}

.rules-section {
  margin-bottom: 16px;

  &:last-child { margin-bottom: 0; }
}

.rules-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f5f5f5;
}

.rules-item {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  padding-left: 4px;
}

.rules-note {
  color: #999;
  font-size: 12px;
  margin-top: 4px;
}

.rules-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th {
    background: #fafafa;
    color: #666;
    font-weight: bold;
    padding: 6px 8px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  td {
    color: #333;
    padding: 5px 8px;
    border-bottom: 1px solid #f5f5f5;
  }
}
</style>
